import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { styled } from "@mui/material/styles";
import { Typography, Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import useResponsive from "../hooks/useResponsive";
import Logo from "../components/Logo";
import { SignUpForm } from "../sections/auth/signup";
import SimpleFooter from "../components/SimpleFooter";

const StyledPageContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
});

const ContentWrapper = styled("div")(({ theme }) => ({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const StyledSection = styled("div")(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("md")]: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(3, 4),
    backgroundColor: theme.palette.background.default,
  },
}));

const StyledContent = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  padding: theme.spacing(8, 3, 2, 3),
  overflowY: "auto",
  [theme.breakpoints.up("md")]: {
    width: "35%",
    alignItems: "center",
    padding: theme.spacing(3, 4),
  },
}));

const FormContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: 480,
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(6, 5),
    boxShadow: theme.shadows[8],
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius * 2,
    border: `1px solid ${theme.palette.divider}`,
  },
}));

const welcomeHeadings = [
  "Join Our Community!",
  "Create Your Profile",
  "Start Your Journey",
  "Welcome to Contactie!",
];

const welcomeSubheadings = [
  "Build trust and showcase your skills.",
  "Connect, get rated, and grow your reputation.",
  "Let your professional profile speak for you.",
  "Stand out with real, verified credibility.",
];

const getRandomMessages = () => {
  const heading =
    welcomeHeadings[Math.floor(Math.random() * welcomeHeadings.length)];
  const subheading =
    welcomeSubheadings[Math.floor(Math.random() * welcomeSubheadings.length)];
  return { heading, subheading };
};

export default function SingUpPage() {
  const mdUp = useResponsive("up", "md");
  const [welcomeMessages] = useState(getRandomMessages);

  return (
    <>
      <Helmet>
        <title>Sign Up | Contactie</title>
      </Helmet>
      <StyledPageContainer>
        {" "}
        <ContentWrapper>
          {" "}
          <Box
            component="header"
            sx={{
              display: { xs: "none", md: "block" },
              position: "absolute",
              zIndex: 10,
              top: 40,
              left: 40,
            }}
          >
            <Logo sx={{ height: 30, width: "auto" }} />
          </Box>
          {mdUp && (
            <StyledSection>
              <Typography
                variant="h4"
                sx={{ textAlign: "center", mb: 2, px: 5 }}
              >
                {welcomeMessages.heading}
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: "text.secondary", textAlign: "center" }}
              >
                {welcomeMessages.subheading}
              </Typography>
              <Box
                component="img"
                src="/assets/illustrations/illustration_register.png"
                alt="Sign Up Illustration"
                sx={{
                  width: "100%",
                  maxWidth: 400,
                  objectFit: "contain",
                  mt: 4,
                }}
              />
            </StyledSection>
          )}
          <StyledContent>
            <FormContainer>
              <Box
                sx={{
                  mb: 3,
                  display: { xs: "flex", md: "none" },
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Logo sx={{ height: 35, width: "auto", mb: 3 }} />
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
                  Get started for free or{" "}
                  <Link component={RouterLink} to="/login" underline="hover">
                    Sign in
                  </Link>
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {welcomeMessages.subheading}
                </Typography>
              </Box>

              <Box sx={{ display: { xs: "none", md: "block" }, mb: 3 }}>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
                  Get started for free or{" "}
                  <Link component={RouterLink} to="/login" underline="hover">
                    Sign in
                  </Link>
                </Typography>
                {/* <Typography variant="body2" sx={{ mt: 3, textAlign: 'center' }}>
              Already have an account?{' '}
              <Link component={RouterLink} to="/login" variant="subtitle2">
                Sign in
              </Link>
            </Typography> */}
              </Box>

              <SignUpForm />

              <Typography
                variant="caption"
                align="center"
                sx={{ color: "text.secondary", mt: 3, display: "block" }}
              >
                By creating an account, you agree to our{" "}
                <Link
                  underline="always"
                  color="text.primary"
                  href="/terms-of-service"
                  target="_blank"
                >
                  Terms of Service
                </Link>{" "}
                and{" "}
                <Link
                  underline="always"
                  color="text.primary"
                  href="/privacy-policy"
                  target="_blank"
                >
                  Privacy Policy
                </Link>
                .
              </Typography>
            </FormContainer>
          </StyledContent>
        </ContentWrapper>{" "}
        <SimpleFooter />
      </StyledPageContainer>{" "}
    </>
  );
}
